// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.popup--old-page[data-v-fa1155b6]{height:100%;width:100%}.block--cookie[data-v-fa1155b6]{position:fixed;left:1.6rem;bottom:.8rem;margin-right:1.6rem}@media (min-width:768px){.block--cookie[data-v-fa1155b6]{bottom:1.6rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
